import { get } from 'lodash';

const defaultSortColumn = {
	sortDirection: 'asc',
	id: 'date',
};

export const myPaymentsToAuthorise = (state) => get(state, 'payments.myPaymentsToAuthorise', []);
export const getMyPaymentsSortAscending = (state) => get(state, 'payments.myPaymentsSortAscending', true);
export const getMyPaymentsSortColumn = (state) => get(state, 'payments.myPaymentsSortColumn', defaultSortColumn);
export const getOtherUserPaymentsSortAscending = (state) => get(state, 'payments.otherUserPaymentsSortAscending', true);
export const getOtherUserPaymentsSortColumn = (state) =>
	get(state, 'payments.otherUserPaymentsSortColumn', defaultSortColumn);
export const otherUserPaymentsToAuthorise = (state) => get(state, 'payments.otherUserPaymentsToAuthorise', []);
export const allAccountPaymentsToAuthorise = (state) => get(state, 'payments.allAccountPaymentsToAuthorise', []);
export const getShowExpiredPayments = (state) => get(state, 'payments.showExpired', false);
